import { SaleroomLiveBids } from './SaleroomLiveBids';
import { SaleroomCharges } from './SaleroomCharges';
import { ShipFromConfig } from './ShipFromConfig';
import type { SaleroomChargeRow } from '../../lib/saleroom-admin-queries';

// Saleroom: live bid management, winner charges/refunds, and ship-from config.
// The notification pipeline now lives in its own Admin -> Notifications section.
// Charges data lives in the shell so its outstanding count can badge the top
// nav without opening the section.

function cls(on: boolean) {
  return on ? 'admin__subpanel' : 'admin__subpanel admin__panel--hidden';
}

export function SaleroomSection({
  tab,
  charges,
}: {
  tab: string;
  charges: {
    rows: SaleroomChargeRow[];
    loading: boolean;
    loaded: boolean;
    error: string | null;
    onRefresh: () => void;
  };
}) {
  return (
    <>
      <div className={cls(tab === 'bids')}>
        <SaleroomLiveBids active={tab === 'bids'} />
      </div>
      <div className={cls(tab === 'charges')}>
        <SaleroomCharges
          rows={charges.rows}
          loading={charges.loading}
          loaded={charges.loaded}
          error={charges.error}
          onRefresh={charges.onRefresh}
        />
      </div>
      <div className={cls(tab === 'shipping')}>
        <ShipFromConfig />
      </div>
    </>
  );
}
